import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

/**
 * Ensures password-recovery links always land on /reset-password.
 * Some email providers/trackers may open the app on / or /home with the recovery hash.
 */
export default function AuthRecoveryRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const redirectIfRecoveryHash = () => {
      const hash = window.location.hash.startsWith("#")
        ? window.location.hash.slice(1)
        : window.location.hash;
      const params = new URLSearchParams(hash);
      const type = params.get("type");
      const accessToken = params.get("access_token");

      // If the link contains a recovery hash, always go to the reset screen.
      if (type === "recovery" && accessToken) {
        if (location.pathname !== "/reset-password") {
          navigate("/reset-password" + window.location.hash, { replace: true });
        }
      }
    };

    redirectIfRecoveryHash();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event) => {
      if (event === "PASSWORD_RECOVERY") {
        if (location.pathname !== "/reset-password") {
          navigate("/reset-password" + window.location.hash, { replace: true });
        }
      }
    });

    // Also re-check if the route changes (some apps redirect to /home quickly)
    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, navigate]);

  return null;
}
